import { Container, Content } from "react-bulma-components";
import styled from "styled-components";
import SimpleBar from "simplebar-react";
import "simplebar/dist/simplebar.min.css";

const ModalContainer = styled(Container)`
  color: lavender;
`;

const ModalH2 = styled.h2`
  color: lavender !important;
`;

const ModalLink = styled.a`
  color: lavender;
  &:visited {
    color: smoke;
  }
`;
function About({ ...props }) {
  return (
    <ModalContainer>
      <Content>
        Care is an autobiography, musical, animation and diary entry that
        explores the social care system, friendship and angst through the eyes
        of abike who's been moved from foster home to foster home and what
        happens when her sister goes missing.
      </Content>
    </ModalContainer>
  );
}

export function News({ ...props }) {
  return (
    <ModalContainer>
      <Content style={{ height: "100%" }}>
        <ModalH2>Screening Dates</ModalH2>
        <hr />
        <div>
          <ModalLink
            href="https://klein1997.bandcamp.com/merch/care-cinema-ticket"
            target="_blank"
            rel="noreferrer noopener"
          >
            Friday 15th October: London, Peckhamplex
          </ModalLink>
        </div>
        <br />
        <div>
          <ModalLink
            href="https://cubecinema.com/programme/event/care-a-film-by-klein,11968/"
            target="_blank"
            rel="noreferrer noopener"
          >
            Sunday 17th October: Bristol, The Cube
          </ModalLink>
        </div>
        <br />
        <div>
          <ModalLink
            href="https://www.fatout.info/event-details/fat-out-fest-2021"
            target="_blank"
            rel="noreferrer noopener"
          >
            Saturday 30th October: Manchester, Fat Out Festival
          </ModalLink>
        </div>
      </Content>
    </ModalContainer>
  );
}

export function Credits({ ...props }) {
  return (
    <ModalContainer>
      <SimpleBar style={{ height: "100%" }}>
        <div>
          <Content style={{ height: "100%" }}>
            <div>Directed by Klein</div>
            <br />
            <div>Executive Producers, Qu Junktions, Klein</div>
            <div>Associate Producer Alexandria Animba</div>
            <div>Score by Klein</div>
            <div>Animation Designer by Evie O'connor</div>
            <div>Animation and Editing by Klein</div>
            <div>
              Additional Camerawork /editing by Musti for tiktok sequence
            </div>
            <div>Artwork assistant Alexandria Animba</div>
            <div>
              Costume Design Cast own clothes/ Klein / Alexandria Animba
              <br />
              additional music - 'win or lose' by chamber 45 for scene where
              kibo is spitting some barrsssss
            </div>
            <div>
              Featuring the additional voices of Dami Agbonin, Deborah Holman,
              Bianca Scout, Kelsey Lu, Aeja Monet, Amber Joy as the willow girls
              in willow girls scene **reprised from 2018 musical rendition
            </div>
	    <div>
	      Transcription by Aheem Sosa
	    </div>
            <br />
            <div>
              <b>CAST, in order of appearance</b>
              <ul>
                <li>Desola Oloko as Lola</li>
                <li>Mica Levi as Mica</li>
                <li>Klein as Abi</li>
                <li>Khush Jandu Quiney as Khush</li>
                <li>Che Campbell as Che</li>
                <li>Nevaeh Forrester as Nevaeh</li>
                <li>Chardonai Spencer as Chardonai</li>
                <li>Giles King-Ashong as Giles</li>
                <li>Musti as Mo (Vocals)</li>
                <li>Kibo as Daniel (Vocals)</li>
                <li>Asli Adan as Asli</li>
                <li>Ahmed Adan as Ahmed</li>
                <li>Sharmaake Adan as Sharmaake</li>
                <li>Fred Moten as Fatherly figure (or Dad)</li>
                <li>Shahab valizadeh as shahab</li>
                <li>Victoria Chunda-Esien as Victoria</li>
                <li>Telisha Fowler as Telisha</li>
                <li>Charlotte Whitear as Charlotte</li>
                <li>
                  Isis Powers-Bird as Isis ***appears on care site and end
                  credits
                </li>
                <li>Hakima Ndione as Hakima **cameo**appears on care site</li>
                <li>Anna Winter as Anna</li>
                <li>Tobias Luca O Decker as Tobias</li>
                <li>Ciaran Thapar as adult (not on screen)</li>
                <li>Merlin Mani as Magia</li>
                <li>Dayax as Yordanos Habib **appears on care site</li>
	  	<li>Vivian Oparah as Adaeze Ogundele</li>
                <li>Curtly thomas as the bad guy in animation world</li>
              </ul>
            </div>
            <br />
            <div>
              <div>**appears on care website</div>
              <div>Ozzie Powers-Bird as Ozzie</div>
              <div>
                Josiane M.H Pozi as Friend of Abi’s (appears in a uber boat pic
                in film and) **appears on care website
              </div>
              <div>
                Bette Nunneley as Friend of Abi’s (appears in uber boat pic in
                film and) **appears on care website
              </div>
            </div>
            <br />
            <div>
              {`Many Thanks to literally everyone on a real like c’mon alex we actually did it
Ciaran for being the best person to speak to , &&& for your time <3 (our interview will be on care site) , rory from carney’s community club. 
my friends the cast for trusting me,  evie omggg cartoon network here we come lol 
Viola davis for the strength, koyejo and josi for the constant encouragement yall fully got me
Lorde inc for magia <3 
`}
            </div>
            <br />
            <div>
              Shout out to soulja boy always and mona scott young always.
            </div>
            <br />
            <div>
              The story, all names, characters, and incidents portrayed in this
              production are fictitious and guided but the story is partially
              autobiography written by klein. No identification with actual
              persons (living or deceased), places, buildings, and products is
              intended or should be inferred.
            </div>
          </Content>
        </div>
      </SimpleBar>
    </ModalContainer>
  );
}

export default About;
